import { render, staticRenderFns } from "./practiceSentenceCard.vue?vue&type=template&id=28a0cb71&scoped=true"
import script from "./practiceSentenceCard.vue?vue&type=script&lang=js"
export * from "./practiceSentenceCard.vue?vue&type=script&lang=js"
import style0 from "./practiceSentenceCard.vue?vue&type=style&index=0&id=28a0cb71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a0cb71",
  null
  
)

export default component.exports